import script from "./LiquidityStatsBoxes.vue?vue&type=script&setup=true&lang=ts"
export * from "./LiquidityStatsBoxes.vue?vue&type=script&setup=true&lang=ts"

import "./LiquidityStatsBoxes.vue?vue&type=style&index=0&id=6625a614&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6625a614"]])

export default __exports__